// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import store from './store'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import {
  api
} from './api' // 接口
import i18n from './i18n' // 语言包
import routes from './permission'
import util from './utils/public'
import Print from './utils/print'
import './components/basics'
import Nprogress from 'nprogress'
import vuescroll from 'vuescroll'
import 'nprogress/nprogress.css'
import 'vuescroll/dist/vuescroll.css'
import '../static/Ueditor/ueditor.config.js'
import '../static/Ueditor/ueditor.all.js'
import '../static/Ueditor/lang/zh-cn/zh-cn.js'
import '../static/Ueditor/ueditor.parse.min.js'

import VueClipboard from 'vue-clipboard2'

// import * as fundebug from 'fundebug-javascript'
// import fundebugVue from 'fundebug-vue'
Vue.use(VueClipboard)

Vue.use(vuescroll)
Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: 'big',
  zIndex: 3000
})
Vue.use(Print)
Vue.prototype.$api = api
Vue.prototype.$util = util
// fundebug.apikey = '56f27b98d76e39ea573b64a5f751972e07ca07308451598fb3183dff3d4b6651'
// fundebugVue(fundebug, Vue)

router.beforeEach((to, from, next) => {
  Nprogress.start()
  if (to.path === '/login') {
    window.sessionStorage.removeItem('minitk')
    window.sessionStorage.removeItem('ms_username')
    next()
  } else if (!store.getters.isAuth) {
    api.getIsWeiVersion().then(res => {
      if (res.code === 200) {
        if (!window.sessionStorage.getItem('minitk') && !res.data) {
          next('/login')
        } else {
          api.initUpdateModel().then(res => {
            store.dispatch('getUserPromission', {
              to,
              next,
              routes
            })
          })
        }
      }
    })
  } else {
    next()
  }
})
router.afterEach(() => {
  Nprogress.done()
})

/* eslint-disable no-new */
let vue = new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {
    App
  },
  template: '<App/>'
})
export default vue



// WEBPACK FOOTER //
// ./src/main.js